export default __webpack_public_path__ + "static/media/StoreIcon.0db2feaa.png";